import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Skeleton from '@material-ui/lab/Skeleton';
import React from 'react';
import { ColumnWithStrictAccessor } from 'react-table';

interface Props {
  pageSize: number;
  columns: ColumnWithStrictAccessor<any>[];
}

const TableRowSkeleton = ({ pageSize, columns }: Props) => {
  return (
    <>
      {new Array(pageSize).fill(null).map((v, i) => (
        <TableRow key={i}>
          {columns.map((c) => (
            <TableCell key={c.accessor}>
              <Skeleton />
            </TableCell>
          ))}
        </TableRow>
      ))}
    </>
  );
};

export default TableRowSkeleton;
